import {
  LotterySchema,
  RetailUnitSchema,
  UpcomingDrawsSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetUpcomingDrawsParams = Static<typeof GetUpcomingDrawsParamsSchema>;
export const GetUpcomingDrawsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetUpcomingDrawsParamsSchema' }
);

export type GetUpcomingDrawsResponse = Static<typeof GetUpcomingDrawsResponseSchema>;
export const GetUpcomingDrawsResponseSchema = Type.Object(
  {
    upcomingDraws: UpcomingDrawsSchema,
  },
  { additionalProperties: false, $id: 'GetUpcomingDrawsResponseSchema' }
);
